import normalize from 'json-api-normalize';
import _ from 'lodash';
import slice from 'lodash/slice';
import concat from 'lodash/concat';
import filter from 'lodash/filter';
import fpFilter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import flatMap from 'lodash/fp/flatMap';
import every from 'lodash/every';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import _get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import find from 'lodash/fp/find';
import reduce from 'lodash/fp/reduce';
import isEmpty from 'lodash/isEmpty';
import camelCase from 'lodash/camelCase';
import lastIndexOf from 'lodash/fp/lastIndexOf';
import moment from 'moment';
import axios from 'axios';
import * as convert from 'xml-js';
import isObject from 'lodash/isObject';
import keys from 'lodash/keys';
import api from '../../api';
import { initialState as freelancerOnboardingInitialState } from '../../store/reducers/FreelancerOnboarding';
import { initialState as onboardingInitialState } from '../../store/reducers/Onboarding/initialState';

export const getFirstPath = string =>
  string.substring(0, lastIndexOf('/')(string));

export const routes = {
  default: '/',
  login: '/login',
  createAccount: '/create-account',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  overview: '/overview/:project_id',
  onboarding: '/onboarding',
  getStarted: '/getstarted',
  freelancerPortfolio: '/freelancer-portfolio',
  myProfile: '/my-profile',
  freelancerOnboarding: '/editor-account/:step_key?',
  contact: '/contact',
  payment: '/payment/:project_id?',
  project: '/project/:project_id?',
  notifications: '/notifications',
  notFound: '/404',
  confirmationEmail: '/users/confirmation',
};

export const routesAction = {
  default: () => routes.default,
  login: () => routes.login,
  createAccount: () => routes.createAccount,
  forgotPassword: () => routes.forgotPassword,
  resetPassword: token =>
    `${routes.resetPassword}?reset_password_token=${token}`,
  overview: projectId => `${getFirstPath(routes.overview)}/${projectId}`,
  onboarding: () => routes.onboarding,
  getStarted: () => routes.getStarted,
  myProfile: () => routes.myProfile,
  freelancerOnboarding: (stepKey = '') =>
    `${getFirstPath(routes.freelancerOnboarding)}/${stepKey}`,
  contact: () => routes.contact,
  payment: projectId => `${getFirstPath(routes.payment)}/${projectId}`,
  notFound: () => routes.notFound,
  project: projectId => `${getFirstPath(routes.project)}/${projectId}`,
};

export const contains = (list, filterLocal) =>
  !_(list)
    .filter(filterLocal)
    .isEmpty();

export const addModifiers = (baseClass, modifiers) => {
  const modifiersArray = modifiers || [];
  const mdfrs = modifiersArray.map(modifier =>
    baseClass.concat('--', modifier),
  );

  return baseClass.concat(' ', mdfrs.join(' '));
};

const getSteps = currentStep => findNext => {
  const steps = flow(
    map(overview => onboardingInitialState[overview]),
    flatMap(step => step.onboardingSteps),
  )([
    'basic_information',
    'project_materials',
    'additional_requirements',
    'submit',
  ]);

  const currentIndex = steps.findIndex(step => step.key === currentStep);

  const nextStep = findNext({ steps, currentIndex });

  return nextStep ? nextStep.key : currentStep;
};

export const getNextOnboardingStep = currentStep =>
  getSteps(currentStep)(({ steps, currentIndex }) => steps[currentIndex + 1]);

export const getPrevOnboardingStep = currentStep =>
  getSteps(currentStep)(({ steps, currentIndex }) => steps[currentIndex - 1]);

export const getNextOverviewStep = currentStep => {
  const tree = {
    basic_information: 'project_materials',
    project_materials: 'additional_requirements',
    additional_requirements: 'submit',
  };

  return tree[currentStep];
};

export const getNextFreelancerOnboardingStep = currentStep => {
  const tree = {
    edit_profile: 'experiences',
    experiences: 'skills',
    skills: 'languages',
    languages: 'project_type',
    project_type: 'tagline',
    tagline: 'tagline',
  };
  return tree[currentStep];
};

export const humanize = str => {
  const frags = str.split(/[_-]/);
  for (let i = 0; i < frags.length; i += 1) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }

  return frags.join(' ');
};

export const getPrevOverviewSteps = currentStep => {
  const tree = {
    basic_information: [],
    project_materials: ['basic_information'],
    additional_requirements: ['basic_information', 'project_materials'],
    submit: [
      'basic_information',
      'project_materials',
      'additional_requirements',
    ],
  };

  return tree[currentStep];
};

export const getPrevFreelancerOnboardingStep = currentStep => {
  const tree = {
    edit_profile: 'edit_profile',
    experiences: 'edit_profile',
    skills: 'experiences',
    languages: 'skills',
    project_type: 'languages',
    tagline: 'project_type',
  };
  return tree[currentStep];
};

/**
 * This function return a delayed promise with success or failure.
 * @param {integer} time in milliseconds
 * @param {object} value of success object if the function does not contain the jsonError and error parameters
 * @param {object} jsonError with array of errors if function does not contain the error parameter
 * @param {object} error to be rejected
 * @returns {Promise} rejected or resolved.
 */
export const delayedPromise = (time, value, jsonError, error) =>
  new Promise((resolve, reject) => {
    setTimeout(
      () => (!error ? resolve(jsonError || value) : reject(error)),
      time,
    );
  });

export const Masks = {
  text: false,
  email: false,
  password: false,
  phoneNumber: [
    `(`,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    `)`,
    ` `,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ` `,
    `-`,
    ` `,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
  ],
  dateInput: [
    /[0-9]/,
    /[0-9]/,
    `/`,
    /[0-9]/,
    /[0-9]/,
    `/`,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
  ],
};

export const Regex = {
  site: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/,
  fullName: /^[\w]+[\s]([\w ])+$/,
  number:  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
};

export const noop = () => {};

export const getS3SignatureFormData = (data, file) => {
  const { fields } = data.credentials;
  const {
    key,
    policy,
    success_action_status: successActionStatus,
    acl,
  } = fields;

  const formData = new FormData();
  formData.append('key', key);
  formData.append('policy', policy);
  formData.append('success_action_status', successActionStatus);
  formData.append('acl', acl);
  formData.append('x-amz-credential', fields['x-amz-credential']);
  formData.append('x-amz-algorithm', fields['x-amz-algorithm']);
  formData.append('x-amz-date', fields['x-amz-date']);
  formData.append('x-amz-signature', fields['x-amz-signature']);
  formData.append('file', file);
  return formData;
};

export const sendUpload = file =>
  api
    .getS3signature()
    .then(response => response.data)
    .then(data => {
      const formData = getS3SignatureFormData(data, file);

      return axios.post(data.credentials.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    })
    .then(xml => convert.xml2js(xml.data, { compact: true }))
    // eslint-disable-next-line dot-notation
    .then(json => json.PostResponse.Location['_text']);

export const normalizeJsonProject = json =>
  normalize(json).get([
    'id',
    'created_at',
    'updated_at',
    'status',
    'current_overview_step',
    'current_onboarding_step',
    'project_name',
    'project_brief',
    'project_picture',
    'dropbox_urls',
    'deadline',
    'way_to_manage',
    'means_of_contact',
    'phone_number',
    'email',
    'price_selected',
    'freelancer_id',
    'references.id',
    'references.link',
    'references.internal_id',
    'references.comment',
    'references.checkboxes',
    'project_onboarding_infos.question.key',
    'project_onboarding_infos.question.name',
    'project_onboarding_infos.section.name',
    'project_onboarding_infos.question_response',
    'project_onboarding_infos.input_value',
    'attachments.name',
    'attachments.url',
    'attachments.id',
    'bid_info',
    'bids.id',
    'bids.project_id',
    'bids.freelancer_id',
    'bids.freelancer_price',
    'bids.created_at',
    'bids.updated_at',
    'client',
    'manager',
    'freelancer',
    'final_price',
    'drafts.id',
    'drafts.url',
    'drafts.name',
    'drafts.status',
    'drafts.due_date',
    'drafts.updated_at',
    'comment',
  ]);

/**
 * Return the current step if it is enabled or the next enabled step
 * @param {array} stepsList
 * @param {string} currentStep
 * */
export const getNextEnabledStep = (stepsList, currentStep = '') => {
  if (currentStep) {
    const index = stepsList.findIndex(i => i.key === currentStep);
    const step = stepsList[index];
    return !step.disabled
      ? step.key
      : getNextEnabledStep(_.slice(stepsList, index));
  }

  const [step] = stepsList;
  return !step.disabled
    ? step.key
    : getNextEnabledStep(stepsList.filter(i => i.key !== step.key));
};

/**
 * Return the current step if it is enabled or the previous enabled step
 * @param {array} stepsList
 * @param {string} currentStep
 * */
export const getPrevEnabledStep = (stepsList, currentStep = '') => {
  if (currentStep) {
    const index = stepsList.findIndex(i => i.key === currentStep);
    const step = stepsList[index];
    return !step.disabled
      ? step.key
      : getPrevEnabledStep(_.slice(stepsList, 0, index));
  }

  const step = _.last(stepsList);

  return !step.disabled
    ? step.key
    : getPrevEnabledStep(stepsList.filter(i => i.key !== step.key));
};

export const removeEmptyObjects = array => {
  if (isEmpty(array)) return [];
  return filter(array, item => !every(item, isEmpty));
};

export const getErrorMessages = (
  error,
  message = 'Something went wrong, try again later',
) => {
  const errors = _get(error, 'response.data.errors', [message]);

  if (isObject(errors)) {
    return flow(
      map(k => errors[k]),
      flatMap(value => value),
    )(keys(errors));
  }

  return errors;
};

export const getFirstThreeElements = skills => {
  if (!skills) return [];
  const firstThreeSkills = slice(skills, 0, 3);
  if (skills.length > 3) {
    return concat(firstThreeSkills, `+${skills.length - 3}`);
  }
  return firstThreeSkills;
};

export const mapFreelancerSkillsToDescription = skills =>
  flow(
    get('freelancer_onboarding.freelancerSteps'),
    find({ key: 'skills' }),
    get('cards[0].inner_cards'),
    flatMap('checkboxes'),
    fpFilter(checkbox => _.includes(skills, checkbox.value)),
    map('description'),
  )(freelancerOnboardingInitialState);

const getSkills = (checkboxes, skills, key = 'value') =>
  flow(
    fpFilter(checkbox => _.includes(skills, checkbox.value)),
    map(key),
  )(checkboxes);

/**
 * Map the skill keys into skill descriptions with category
 * @param skills in key format
 * @returns Object {
 *  preProductionDescriptions,
 *  productionDescriptions,
 *  animationDescriptions,
 *  videoEditingDescriptions
 * }
 */
export const mapFreelancerSkillsToDescriptionWithCategory = skills =>
  flow(
    get('freelancer_onboarding.freelancerSteps'),
    find({ key: 'skills' }),
    get('cards[0].inner_cards'),
    reduce(
      (acc, step) => ({
        ...acc,
        [`${camelCase(step.key)}Descriptions`]: getSkills(
          step.checkboxes,
          skills,
          'description',
        ),
      }),
      {},
    ),
  )(freelancerOnboardingInitialState);

/**
 * Get all freelancer skills with category
 * @returns Object {
 *  preProductionValues,
 *  productionValues,
 *  animationValues,
 *  videoEditingValues
 * }
 */
export const getFreelancerSkillsWithCategory = () =>
  flow(
    get('freelancer_onboarding.freelancerSteps'),
    find({ key: 'skills' }),
    get('cards[0].inner_cards'),
    reduce(
      (acc, step) => ({
        ...acc,
        [`${camelCase(step.key)}Values`]: _.map(step.checkboxes, 'value'),
      }),
      {},
    ),
  )(freelancerOnboardingInitialState);

export const getFreelancerPreFilter = currentOnboardingSteps => {
  const params = {
    'q[skills_cont_any]': [],
  };

  const pushSkillsParam = value => {
    params['q[skills_cont_any]'] = _.concat(
      params['q[skills_cont_any]'],
      value,
    );
  };

  const basicRequirements = _.find(
    currentOnboardingSteps.basic_information.onboardingSteps,
    { key: 'basic_requirements' },
  );
  const selectedValues = basicRequirements.selectedValue;
  const freelancerSkills = getFreelancerSkillsWithCategory();

  if (_.includes(selectedValues, 'pre_production')) {
    pushSkillsParam(freelancerSkills.preProductionValues);
  }
  if (_.includes(selectedValues, 'production')) {
    const additionalRequirements = _.find(
      currentOnboardingSteps.additional_requirements.onboardingSteps,
      { key: 'production' },
    );
    const [selectedProductionValue] = additionalRequirements.selectedValue;

    pushSkillsParam(selectedProductionValue);
  }
  if (_.includes(selectedValues, 'animation')) {
    const additionalRequirements = _.find(
      currentOnboardingSteps.additional_requirements.onboardingSteps,
      { key: 'animation' },
    );
    const [selectedAnimationValue] = additionalRequirements.selectedValue;

    pushSkillsParam(selectedAnimationValue);
  }
  if (_.includes(selectedValues, 'video_editing')) {
    pushSkillsParam(freelancerSkills.videoEditingValues);
  }

  return params;
};

export const getBudgetValue = (budget, defaultValue) => {
  if (typeof budget === 'number') {
    return budget;
  }
  return defaultValue;
};

export const scrollUp = (ypos = 0) => {
  window.document.querySelector('body').scrollTop = ypos;
};

export const sortById = (items = []) => sortBy(items, item => item.id);

export const draftToNumber = draft =>
  parseInt(draft.substring(draft.length - 1), 10);

export const isDraftPrevious = (draftA, draftB) =>
  draftToNumber(draftA) < draftToNumber(draftB);

export const getformattedDate = date => {
  if (!date) {
    return '';
  }
  return moment(date, 'YYYY/MM/DD').format('MM-DD-YYYY');
};

export const getReducedDrafts = drafts =>
  drafts.reduce((accumulator, current, i) => {
    // eslint-disable-next-line camelcase
    const { due_date } = current;

    // eslint-disable-next-line no-param-reassign
    accumulator[`draft_${i + 1}`] = {
      ...current,
      // eslint-disable-next-line camelcase
      due_date: due_date ? getformattedDate(due_date) : due_date,
    };

    return accumulator;
  }, {});

export const americanDateToGlobal = date =>
  date ? moment(date, 'MM/DD/YYYY').format() : date;

export const createUrl = url => {
  if (!/^(f|ht)tps?:\/\//i.test(url)) {
    return `http://${url}`;
  }
  return url;
};

export const industries = [
  'Agency',
  'Apparel & Accessories',
  'Athletics',
  'Automotive',
  'Baby/Children',
  'Beer, Wine & Spirits',
  'Beverage (Non-Alcoholic)',
  'Charities & Organizations',
  'Conference/Event',
  'Consumer Goods',
  'Cosmetics',
  'Direct Response Companies',
  'eCommerce',
  'Education',
  'Entertainment & Media',
  'Financial Services',
  'Food',
  'Gaming',
  'General Merchandise',
  'Health & Beauty Care',
  'Home Furnishings',
  'Hospitality',
  'Medical/Pharmaceuticals ',
  'Paper Goods',
  'Pet',
  'Professional Service',
  'Restaurant & Bar',
  'Retailer/Wholesale',
  'Sports & Fitness',
  'Technology & Telecommunications',
  'Travel & Leisure',
  'Other',
];



// WEBPACK FOOTER //
// ./src/shared/helpers/index.js